<template>
    <Dashboard
        :title="__('Engraver', null, $page.props.profile_locale)"
    >
        <Heading
            :label="__('Engraver', null, $page.props.profile_locale)"
        />

        <Tabs
            :link="true"
            :tabs="[
                { slug: 'list', title: __('Engraving variants', null, $page.props.profile_locale), route: route().current() },
                { slug: 'piktogram', title:__('Images', null, $page.props.profile_locale), route: 'dashboard.engrave.pictogram' },
            ]"
        >
            <ItemTab key="list" class="mt-4">
                <div class="grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 gap-3">
                    <div class="shadow-md rounded-md overflow-hidden relative group" v-for="item in engraves.data" :key="item.id">
                        <img :src="item.image.url" class="sm:h-auto lg:h-40 h-60 mx-auto group-hover:opacity-50 transition duration-300"/>

                        <div class="absolute z-20 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 group-hover:opacity-100 opacity-0 transition duration-300 flex">
                            <IconLink
                                class="mx-1 p-1"
                                icon="pencil"
                                :size="30"
                                :href="route('dashboard.engrave.edit', item.id)"
                            />
                            <IconLink
                                class="mx-1 p-1"
                                icon="trash"
                                color="red"
                                :size="30"
                                href="#"
                                @click.prevent="remove(item)"
                            />
                        </div>
                        <div class="absolute inset-0 z-10 group-hover:bg-gray-900 group-hover:bg-opacity-10 transition duration-300">
                            <h2 class="bg-gray-900 text-gray-200 p-1 font-bold">{{ item.name }}</h2>
                        </div>
                    </div>
                    <InertiaLink
                        class="bg-gray-400 bg-opacity-10 rounded-md text-gray-400 p-5 flex items-center justify-center hover:bg-gray-900 hover:bg-opacity-10 transition duration-300 hover:shadow-md"
                        :href="route('dashboard.engrave.create')"
                    >
                        <SvgIcon
                            name="plus"
                            class="w-1/2 h-1/2"
                        />
                    </InertiaLink>
                </div>
                <PaginateLink
                    class="mt-5"
                    :links="engraves.links"
                />
            </ItemTab>
        </Tabs>
    </Dashboard>
</template>

<script>
import Dashboard from '@/Layouts/Dashboard';
import SvgIcon from 'UI/SvgIcon';
import IconLink from 'UI/IconLink';
import { Inertia } from '@inertiajs/inertia';
import Button from 'UI/Button';
import Tabs from 'COMP/Tabs/Container';
import ItemTab from 'COMP/Tabs/Tab';
import { ref } from '@vue/reactivity';
import Heading from 'COMP/Heading';
import { provide } from '@vue/runtime-core';
import PaginateLink from 'UI/PaginateLink';

export default {
    components: { Dashboard, SvgIcon, IconLink, Button, Tabs, ItemTab, Heading, PaginateLink},

    props: {
        engraves: [Array, Object],
        pictogram: Array,
    },

    setup(props) {

        const activeTab = ref(0);

        function remove(ev){
            if(confirm("Czy napewno chcesz usunąć grawer ?")){
                Inertia.visit(route('dashboard.engrave.remove', ev.id), { method: 'post' });
            }
        }

        const loading = ref(true);
        provide('loading', loading);


        return {
            remove,

            activeTab,
        }
    }
}
</script>

<style>

</style>
